import { ArrowRight } from "lucide-react";
import { GROWTH_FACTOR_URL } from "../../data/config";
import { track } from "../../lib/track";

const CONTEXT_LINES = [
  { match: /brand|jenama/i, text: "Jenama mungkin kelihatan seperti masalah utama. Tetapi adakah itu benar-benar bottleneck bisnes anda?" },
  { match: /market|pemasaran/i, text: "Marketing yang perlahan mungkin simptom — bukan punca sebenar." },
  { match: /sales|jualan/i, text: "Jualan yang rendah tidak semestinya bermaksud produk tidak bagus." },
];

export const gfUrl = ({ source, article, position }) =>
  `${GROWTH_FACTOR_URL}?utm_source=${source}&utm_campaign=growth-factor-rm15&utm_content=${article || "direct"}&cta_position=${position}`;

export const GrowthFactorCTA = ({ articleSlug, category = "", position = "article-end", source = "insights" }) => {
  const ctx = (CONTEXT_LINES.find((c) => c.match.test(category)) || {}).text
    || "Daripada meneka apa yang perlu diperbaiki, mulakan dengan diagnosis.";
  const mid = position === "article-mid";
  return (
    <div className={mid ? "my-10 border border-burgundy/20 bg-burgundy/5 p-6" : "mt-14 border border-burgundy/20 bg-burgundy/5 p-8 sm:p-10"} data-testid={`gf-cta-${position}`}>
      <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-burgundy">
        Business Growth Factor · <span className="text-amber">RM15</span>
      </p>
      <p className="mt-3 font-serif text-xl leading-snug text-ink sm:text-2xl">
        {mid ? "Tak pasti di mana bisnes sedang tersekat?" : "Baca masalahnya. Sekarang kenal pasti kedudukan bisnes sendiri."}
      </p>
      <p className="mt-3 text-sm leading-relaxed text-ink/70">
        {mid
          ? "Kenal pasti bottleneck sebenar perniagaan anda dengan diagnosis ringkas."
          : `${ctx} Setiap perniagaan mempunyai kekuatan dan titik tersekat yang berbeza — Growth Factor membantu mengenal pasti kedudukan semasa perniagaan dan langkah seterusnya, berdasarkan jawapan sendiri.`}
      </p>
      <a
        href={gfUrl({ source, article: articleSlug, position })}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          track("gf_cta_click", { source, article: articleSlug, campaign: "growth-factor-rm15", cta_position: position });
          track("growthfactor_checkout_started", { source, article: articleSlug, campaign: "growth-factor-rm15", cta_position: position });
        }}
        className="btn-primary mt-5"
        data-testid={`gf-cta-button-${position}`}
      >
        {mid ? "Kenal Pasti Growth Factor Saya — RM15" : "Diagnos Bisnes Saya — RM15"} <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
      </a>
      <p className="mt-3 text-[11px] uppercase tracking-[0.15em] text-ink/45">
        Jawab assessment → Kenal pasti bottleneck → Terima laporan peribadi
      </p>
    </div>
  );
};
